/** Hardcoded, read-only sample projects for the public sector demos. No real customer data. */
const SECTORS = {
  "solar-epc": {
    name: "Solar EPC",
    project: "Rajasthan Solar Phase II",
    client: "NTPC Renewable Energy Ltd",
    value: 85,
    location: "Jodhpur, Rajasthan",
    type: "Solar EPC — 150 MW ground mount",
    planned: "2026-11-30",
    actual: "2026-12-18",
    acts: [
      ["Land levelling & grading", "Cu.M", 420000, "Sanjay Meena — Civil"],
      ["Pile driving & MMS foundation", "Nos", 18400, "R. Choudhary — Civil"],
      ["Module mounting structure erection", "MT", 3120, "Vikas Sharma — Structural"],
      ["PV module mounting", "Nos", 272000, "Priya Nair — Execution"],
      ["DC string cabling & termination", "RMT", 186000, "A. Rathore — Electrical"],
      ["Inverter & transformer installation", "Nos", 46, "Deepak Joshi — Electrical"],
      ["Internal roads & drainage", "RMT", 14200, "Sanjay Meena — Civil"],
      ["ICR & pooling substation works", "MT", 640, "Deepak Joshi — Electrical"],
      ["Grid connection & bay extension", "Nos", 2, "M. Iyer — Grid"],
      ["String testing & commissioning", "Nos", 1360, "Priya Nair — Commissioning"],
    ],
    boq: [
      ["PV module 545 Wp mono PERC", "Nos", 272000, 251400, 11800],
      ["Module mounting structure — galvanised", "MT", 3120, 2740, 96500],
      ["Foundation pile — driven", "Nos", 18400, 17960, 4350],
      ["String inverter 250 kW", "Nos", 46, 38, 1120000],
      ["DC cable 4 sq.mm solar grade", "RMT", 186000, 171200, 68],
      ["Earthing & lightning protection", "Nos", 2400, 2180, 3250],
      ["Internal road — WBM", "RMT", 14200, 11800, 2850],
    ],
    risks: [
      ["green", "Module supply on track", "Container arrivals for blocks 1–6 are ahead of the mounting rate; 92% of DC capacity is on site.", "Hold the current mounting crew strength through the month.", "No impact on the PPA date."],
      ["amber", "Inverter delivery slipping", "8 of 46 inverters are still in transit; block 7–9 AC commissioning depends on them.", "Escalate with the OEM and re-sequence commissioning to blocks 1–6 first.", "12 days on AC commissioning if not recovered in 3 weeks."],
      ["red", "Grid bay extension behind schedule", "STU bay extension is 34 days behind, and evacuation readiness now drives the critical path, not module mounting.", "Weekly joint review with the STU; prepare an extension-of-time notice with the dated hindrance record.", "18 days on synchronisation — currently the single largest exposure."],
    ],
    dpr: ["Clear, 41°C", 486, "Module mounting crossed 6,200 modules for the day across blocks 3 and 4 — the best day this month. Pile driving in block 7 was held for four hours waiting on the rig shifting; logged as a hindrance. DC cabling in block 2 is ready for string testing from tomorrow."],
  },
  "wind-epc": {
    name: "Wind EPC",
    project: "Gujarat Wind Farm Cluster 3",
    client: "Adani Green Energy Ltd",
    value: 120,
    location: "Kutch, Gujarat",
    type: "Wind EPC — 24 × 3.0 MW WTG",
    planned: "2027-02-28",
    actual: "2027-03-22",
    acts: [
      ["Access road & crane platform", "RMT", 21600, "H. Patel — Civil"],
      ["WTG foundation excavation", "Cu.M", 34800, "H. Patel — Civil"],
      ["Foundation concreting & curing", "Cu.M", 12960, "Nilesh Rana — Civil"],
      ["Anchor cage & template setting", "Nos", 24, "Nilesh Rana — Civil"],
      ["Tower section erection", "Nos", 96, "S. Bhatt — Erection"],
      ["Nacelle installation", "Nos", 24, "S. Bhatt — Erection"],
      ["Blade assembly & hub fitting", "Nos", 72, "K. Solanki — Erection"],
      ["Internal cabling 33 kV", "RMT", 48200, "R. Trivedi — Electrical"],
      ["Pooling substation & line stringing", "MT", 410, "R. Trivedi — Electrical"],
      ["Pre-commissioning & charging", "Nos", 24, "K. Solanki — Commissioning"],
    ],
    boq: [
      ["Foundation concrete M35", "Cu.M", 12960, 11240, 7450],
      ["Foundation reinforcement steel", "MT", 1680, 1512, 68500],
      ["Tower section — 3 piece", "Nos", 96, 74, 4850000],
      ["Nacelle assembly 3.0 MW", "Nos", 24, 18, 41000000],
      ["Blade set 68 m", "Nos", 72, 54, 8600000],
      ["33 kV XLPE cable", "RMT", 48200, 39400, 1480],
      ["Crane platform — GSB & compaction", "Cu.M", 18400, 16900, 1950],
    ],
    risks: [
      ["green", "Foundation cycle stable", "Foundation pours are averaging one WTG every 9 days against a plan of 10, with curing periods respected.", "Maintain two concurrent foundation crews.", "Two days ahead on the foundation package."],
      ["amber", "Blade consignment held at ghat section", "Two blade sets are held pending police escort clearance on the ghat approach; the 600 T crane is on standby at WTG-14.", "Pre-clear escorts for the next three consignments and shift the crane to WTG-16 meanwhile.", "6–8 days, plus idle crane cost of about ₹34 lakh."],
      ["red", "Pooling substation charging at risk", "Line stringing is 28 days behind and now controls first charging for the whole cluster.", "Add a second stringing gang and hold weekly joint reviews with the transmission agency.", "22 days on cluster charging."],
    ],
    dpr: ["Windy, 33°C", 214, "Nacelle for WTG-13 was lifted and bolted within the morning wind window. Blade assembly for WTG-12 stopped at 11:40 as wind speed crossed the erection limit — three hours idle, logged. 33 kV cable pulling continued between WTG-9 and the pooling station."],
  },
  "engineering-epc": {
    name: "Engineering EPC",
    project: "Pune Petrochemical Facility",
    client: "Reliance Industries Ltd",
    value: 340,
    location: "Pune, Maharashtra",
    type: "Multi-discipline EPC — process unit",
    planned: "2027-06-30",
    actual: "2027-08-10",
    acts: [
      ["Site grading & piling", "Nos", 2840, "A. Kulkarni — Civil"],
      ["Foundations & pipe racks (civil)", "Cu.M", 28600, "A. Kulkarni — Civil"],
      ["Structural steel fabrication", "MT", 7400, "S. Pawar — Structural"],
      ["Structural steel erection", "MT", 7400, "S. Pawar — Structural"],
      ["Static equipment erection", "Nos", 68, "V. Deshmukh — Mechanical"],
      ["Rotary equipment installation", "Nos", 42, "V. Deshmukh — Mechanical"],
      ["Piping prefabrication", "Dia-Inch", 186000, "R. Jadhav — Piping"],
      ["Piping erection & welding", "Dia-Inch", 186000, "R. Jadhav — Piping"],
      ["Cable tray & power cabling", "RMT", 214000, "N. Shinde — Electrical"],
      ["Instrumentation & loop checking", "Nos", 4180, "P. Bhosale — Instrumentation"],
    ],
    boq: [
      ["Structural steel — fabricated & erected", "MT", 7400, 6180, 108000],
      ["Piping CS — erection & welding", "Dia-Inch", 186000, 142800, 2450],
      ["Foundation concrete M40", "Cu.M", 28600, 25400, 8100],
      ["Static equipment — erection", "Nos", 68, 51, 1850000],
      ["Power & control cable", "RMT", 214000, 168000, 420],
      ["Field instruments — install & loop check", "Nos", 4180, 2940, 18500],
      ["Painting & insulation", "Sq.M", 96000, 71400, 640],
    ],
    risks: [
      ["green", "Structural erection ahead of piping", "Steel erection is holding 340 MT a month, keeping the piping front unblocked in units 1 and 2.", "Protect the erection crew from reallocation to unit 4.", "No impact; two weeks of buffer created for piping."],
      ["amber", "Piping welder productivity below plan", "Dia-Inch per welder per day is running at 4.8 against a planned 6.2, largely from spool availability rather than manpower.", "Increase prefabrication ahead of erection and re-balance spool despatch to unit 3.", "About 15 days on mechanical completion."],
      ["red", "Instrumentation loop checking compressed", "Loop checking has only 6 weeks against a realistic 11, and it sits directly on the critical path to pre-commissioning.", "Mobilise a second I&C agency now and start loop checking system by system rather than after full completion.", "28 days on pre-commissioning readiness."],
    ],
    dpr: ["Overcast, 29°C", 1284, "Unit 2 pipe rack steel reached 92% erected. Piping welding across all fronts closed 640 Dia-Inch against a target of 780; three welders were idle in the afternoon awaiting spools from the fab yard. Instrument cable laying started in the unit 1 substation."],
  },
  hvac: {
    name: "HVAC",
    project: "Mumbai Data Centre HVAC",
    client: "Tata Communications Ltd",
    value: 18,
    location: "Mumbai, Maharashtra",
    type: "HVAC — Tier III data centre, 12 MW IT load",
    planned: "2026-10-15",
    actual: "2026-10-29",
    acts: [
      ["Duct fabrication — shop", "Sq.M", 34600, "F. Merchant — Fabrication"],
      ["Duct erection & supports", "Sq.M", 34600, "F. Merchant — Execution"],
      ["Chiller plant installation", "Nos", 6, "G. Sawant — Mechanical"],
      ["CRAH / AHU installation", "Nos", 84, "G. Sawant — Mechanical"],
      ["Chilled water piping", "RMT", 4180, "D. Kadam — Piping"],
      ["Insulation & cladding", "Sq.M", 12800, "D. Kadam — Execution"],
      ["BMS integration & cabling", "Nos", 1240, "S. Fernandes — Controls"],
      ["TAB & commissioning", "Nos", 84, "S. Fernandes — Commissioning"],
    ],
    boq: [
      ["GI ducting 24G — fabricated", "Sq.M", 34600, 31200, 1240],
      ["Water-cooled chiller 800 TR", "Nos", 6, 4, 14800000],
      ["CRAH unit — precision cooling", "Nos", 84, 62, 1680000],
      ["Chilled water piping MS", "RMT", 4180, 3640, 3850],
      ["Nitrile insulation 25 mm", "Sq.M", 12800, 10400, 890],
      ["BMS field devices & integration", "Nos", 1240, 810, 14200],
    ],
    risks: [
      ["green", "Duct fabrication ahead of erection", "The shop is holding a 4-week buffer over site erection, so no crew has waited on fabrication this month.", "Keep the fabrication shop on the current shift pattern.", "No impact; buffer protects the erection sequence."],
      ["amber", "Two chillers pending delivery", "4 of 6 chillers are installed; the remaining two are due in 5 weeks, which compresses plant-room commissioning.", "Confirm the despatch date in writing and pre-complete all piping and electrical interfaces at the two vacant bases.", "10–14 days on plant-room commissioning."],
      ["red", "BMS integration behind, blocks TAB", "BMS field device installation is at 65% with integration testing not started; TAB cannot begin without it and the client handover date is fixed.", "Add a dedicated controls team and start zone-wise TAB on completed halls rather than waiting for full BMS closure.", "21 days on handover if integration is not accelerated now."],
    ],
    dpr: ["Humid, 31°C", 168, "Hall 3 ducting reached 88% erected and pressure testing cleared on two branches. Chilled water piping welding continued in the plant room. BMS cabling in Hall 2 was held for six hours pending cable tray handover from the electrical contractor — logged as a hindrance."],
  },
  "nuclear-projects": {
    name: "Nuclear Projects",
    project: "Kudankulam Unit 5 Civil Works",
    client: "Nuclear Power Corporation of India Ltd",
    value: 2200,
    location: "Tirunelveli, Tamil Nadu",
    type: "Nuclear civil works — containment package",
    planned: "2029-03-31",
    actual: "2029-06-15",
    acts: [
      ["Excavation & raft preparation", "Cu.M", 186000, "K. Subramanian — Civil"],
      ["Raft foundation concreting", "Cu.M", 42800, "K. Subramanian — Civil"],
      ["Inner containment wall — lift 1 to 6", "Cu.M", 68400, "R. Balaji — Civil"],
      ["Containment liner plate erection", "MT", 4260, "M. Prakash — Structural"],
      ["Reactor building internal structures", "Cu.M", 51600, "R. Balaji — Civil"],
      ["Turbine hall foundations & pedestal", "Cu.M", 38200, "S. Anand — Civil"],
      ["Cooling water intake structure", "Cu.M", 74800, "S. Anand — Civil"],
      ["Embedded parts & anchor installation", "Nos", 18600, "M. Prakash — Mechanical"],
      ["Electrical & cable gallery works", "RMT", 24800, "V. Ganesh — Electrical"],
      ["QA hold-point clearances & documentation", "Nos", 1840, "T. Rajan — QA"],
    ],
    boq: [
      ["Concrete M50 — containment grade", "Cu.M", 68400, 41200, 12400],
      ["Reinforcement steel — containment", "MT", 18600, 11800, 78500],
      ["Liner plate — fabricated & erected", "MT", 4260, 2140, 186000],
      ["Embedded parts & anchors", "Nos", 18600, 10400, 8600],
      ["Raft concrete M40", "Cu.M", 42800, 42800, 9800],
      ["Post-tensioning tendons", "MT", 1240, 380, 340000],
      ["Cooling water intake — concrete", "Cu.M", 74800, 38600, 8900],
    ],
    risks: [
      ["green", "Raft package complete and cleared", "The raft is 100% complete with all QA hold points cleared and documentation signed at each stage.", "Archive the clearance pack against each activity for the licensing file.", "No impact; the package closed two weeks early."],
      ["amber", "Liner plate erection rate below plan", "Erection is at 2,140 MT of 4,260 MT with a rate of 118 MT a month against 145 MT required for the containment wall sequence.", "Add a second erection crew on the night shift and pre-stage plates closer to the lift.", "About 19 days on containment wall completion."],
      ["red", "Hold-point clearance backlog", "34 QA hold points are awaiting joint inspection; concrete lifts 5 and 6 cannot proceed and the crew is partially idle.", "Daily joint inspection slot with the owner's QA, and sequence clearances in the order that unblocks the next lift.", "26 days on the containment wall, cascading to liner and PT works."],
    ],
    dpr: ["Clear, 34°C", 2140, "Containment wall lift 4 concreting was completed with continuous pour over 19 hours; all mandatory tests recorded and witnessed. Lift 5 rebar tying is at 70%. Liner plate erection continued at El. +21.5 m. Hold-point clearance for the embedded parts in sector C is still pending with owner QA — logged."],
  },
  "thermal-power-plant": {
    name: "Thermal Power Plant",
    project: "Vindhyachal Unit 7 Erection",
    client: "NTPC Ltd",
    value: 780,
    location: "Singrauli, Madhya Pradesh",
    type: "Thermal — 1 × 660 MW supercritical",
    planned: "2027-09-30",
    actual: "2027-11-12",
    acts: [
      ["Boiler structure erection", "MT", 14800, "R. Tiwari — Structural"],
      ["Boiler pressure parts erection", "MT", 9600, "R. Tiwari — Mechanical"],
      ["ESP & ducting erection", "MT", 6200, "A. Mishra — Mechanical"],
      ["TG deck & turbine setting", "MT", 3400, "S. Dubey — Mechanical"],
      ["Condenser installation", "Nos", 1, "S. Dubey — Mechanical"],
      ["High pressure piping", "Dia-Inch", 84600, "P. Verma — Piping"],
      ["Coal handling plant — conveyors", "MT", 5400, "K. Yadav — Mechanical"],
      ["Ash handling & water systems", "MT", 2800, "K. Yadav — Mechanical"],
      ["Switchyard & electrical erection", "MT", 1900, "N. Gupta — Electrical"],
      ["Hydro test, boiler light-up & synchronisation", "Nos", 1, "S. Dubey — Commissioning"],
    ],
    boq: [
      ["Boiler structural steel", "MT", 14800, 12640, 96500],
      ["Pressure parts — erection", "MT", 9600, 6820, 148000],
      ["High pressure piping — welding", "Dia-Inch", 84600, 58400, 4200],
      ["Turbine generator — setting & alignment", "MT", 3400, 2180, 210000],
      ["ESP & flue ducting", "MT", 6200, 4960, 88000],
      ["Coal conveyor structures & idlers", "MT", 5400, 3240, 79500],
      ["Switchyard structures & equipment", "MT", 1900, 980, 118000],
    ],
    risks: [
      ["green", "Boiler structure on plan", "Structural erection is averaging 420 MT a month against a plan of 400, keeping pressure parts unblocked.", "Maintain three shifts on the boiler structure until the drum lift.", "About 5 days of float created ahead of the drum lift."],
      ["amber", "HP piping welding lagging", "58,400 of 84,600 Dia-Inch complete; the current rate leaves the balance about 5 weeks short of the hydro test window.", "Add 14 qualified welders and prioritise the main steam and hot reheat lines.", "12–16 days on the hydro test date."],
      ["red", "Coal handling plant far behind", "CHP conveyor erection is at 60% with civil handover still pending on junction towers 4 and 5, and CHP now controls trial run readiness.", "Escalate the civil handover to a weekly owner review and start conveyor erection on completed stretches in parallel.", "31 days on trial run and COD."],
    ],
    dpr: ["Hazy, 38°C", 1860, "Pressure parts erection closed 96 MT across the second pass and economiser. HP piping welding achieved 214 Dia-Inch against a target of 280 — two welders were diverted to a repair joint. TG deck grouting completed. Night shift progressed ESP internals; 22 workers idled for five hours awaiting a crane in the CHP area."],
  },
  "other-infrastructure": {
    name: "Other Infrastructure",
    project: "Delhi-Meerut Expressway Package 4",
    client: "National Highways Authority of India",
    value: 95,
    location: "Delhi – Uttar Pradesh border",
    type: "Highway — 6 lane, 22 km package",
    planned: "2026-12-31",
    actual: "2027-01-24",
    acts: [
      ["Clearing, grubbing & utility shifting", "RMT", 22000, "R. Sehrawat — Civil"],
      ["Earthwork in embankment", "Cu.M", 1240000, "R. Sehrawat — Civil"],
      ["Subgrade preparation", "Cu.M", 186000, "M. Chauhan — Civil"],
      ["Granular sub-base (GSB)", "Cu.M", 148000, "M. Chauhan — Civil"],
      ["Wet mix macadam base course", "Cu.M", 121000, "S. Tomar — Pavement"],
      ["DBM & bituminous concrete", "MT", 214000, "S. Tomar — Pavement"],
      ["Culverts & minor bridges", "Nos", 46, "A. Kaushik — Structures"],
      ["Major bridge — 4 span VUP", "Nos", 3, "A. Kaushik — Structures"],
      ["Drainage & protection works", "RMT", 34800, "R. Sehrawat — Civil"],
      ["Road furniture, marking & signage", "RMT", 22000, "P. Bisht — Execution"],
    ],
    boq: [
      ["Earthwork in embankment", "Cu.M", 1240000, 1084000, 285],
      ["Granular sub-base", "Cu.M", 148000, 121400, 1480],
      ["Wet mix macadam", "Cu.M", 121000, 92600, 1860],
      ["Dense bituminous macadam", "MT", 214000, 148200, 6850],
      ["RCC culverts", "Nos", 46, 34, 1840000],
      ["VUP — 4 span structure", "Nos", 3, 1, 68000000],
      ["Drainage — lined drain", "RMT", 34800, 24600, 2450],
    ],
    risks: [
      ["green", "Earthwork nearly closed", "Embankment is at 87% with borrow areas secured through the season; no stretch is waiting on earthwork.", "Release two excavator crews to the drainage front.", "No impact; earthwork will close ahead of the pavement window."],
      ["amber", "Utility shifting pending at 2 stretches", "HT line shifting between chainage 11+400 and 12+900 is pending with the discom, holding GSB in that stretch.", "Follow the sanctioned estimate with the discom weekly and re-sequence the paving train to cleared stretches.", "8–10 days on the pavement sequence for those chainages."],
      ["red", "VUP structures behind schedule", "Only 1 of 3 VUPs is complete; the remaining two control the corridor opening and the segment casting rate is below plan.", "Add a second casting yard and a launching girder shift, and review the milestone billing plan accordingly.", "24 days on corridor opening."],
    ],
    dpr: ["Clear, 36°C", 742, "Embankment closed 4,180 Cu.M across chainage 14+000 to 16+200. DBM paving ran two trains and laid 1,240 MT. GSB in the 11+400 to 12+900 stretch remained stopped for the ninth day pending HT line shifting — logged as a client-side hindrance with cost impact. Culvert at 15+600 completed and cured."],
  },
};

const round = (n, d = 0) => Number(n.toFixed(d));

/** Deterministic pseudo-progress so demos look realistic but never change between visits. */
function build(slug, s) {
  const acts = s.acts.map(([name, unit, qty, owner], i) => {
    const planned = round(96 - i * 6.5 + (i % 3) * 4, 1);
    const drift = [0, -4, -14, 2, -9, -22, 1, -6, -31, -11][i % 10];
    const actual = Math.max(0, round(Math.min(planned + drift, 100), 1));
    const gap = actual - planned;
    return {
      id: `${slug}-a${i + 1}`,
      code: `L3-${String(i + 1).padStart(2, "0")}`,
      name, unit, owner,
      qty,
      done: Math.round((qty * actual) / 100),
      planned, actual,
      status: gap >= -3 ? "On Track" : gap >= -15 ? "Delayed" : "Critical",
    };
  });
  const boq = s.boq.map(([desc, unit, plannedQty, actualQty, rate], i) => ({
    id: `${slug}-b${i + 1}`,
    desc, unit, plannedQty, actualQty, rate,
    plannedValue: plannedQty * rate,
    actualValue: actualQty * rate,
    variancePct: round(((actualQty - plannedQty) / plannedQty) * 100, 1),
  }));
  const overall = round(acts.reduce((a, x) => a + x.actual, 0) / acts.length, 1);
  const plannedOverall = round(acts.reduce((a, x) => a + x.planned, 0) / acts.length, 1);
  const risk = s.risks.some((r) => r[0] === "red") ? "Red" : s.risks.some((r) => r[0] === "amber") ? "Amber" : "Green";
  return {
    slug,
    sector: s.name,
    meta: {
      title: `${s.name.replace(/\s*EPC$/, "")} EPC Project Management Demo — Plan-Sarthi`,
      description: `Explore a live read-only ${s.name} demo project on Plan-Sarthi — WBS, BOQ, AI risk radar, DPR and WhatsApp alerts for ${s.project} (${s.location}). No sign-up required.`,
    },
    project: {
      name: s.project, client: s.client, value: s.value, location: s.location, type: s.type,
      plannedFinish: s.planned, forecastFinish: s.actual, overall, plannedOverall, risk,
    },
    acts, boq,
    risks: s.risks.map(([level, title, body, mitigation, impact]) => ({ level, title, body, mitigation, impact })),
    dpr: {
      date: "2026-06-24",
      progress: overall,
      completedToday: acts.filter((a) => a.actual >= 99).length + 2,
      weather: s.dpr[0],
      workforce: s.dpr[1],
      narrative: s.dpr[2],
    },
  };
}

export const DEMOS = Object.fromEntries(Object.entries(SECTORS).map(([slug, s]) => [slug, build(slug, s)]));
export const DEMO_SLUGS = Object.keys(SECTORS);
